// extracted by css-extract-rspack-plugin
export default {"Overlay":"soN1a","z1":"Nsvne","z2":"RYWvA","z3":"ODutq","z4":"hMTsk","z5":"RDlqR","z6":"WKfZg"};